<div class="n-tela-cadastro">
  <div class="n-container">
    <!-- Conteúdo principal em duas colunas -->
    <div class="n-tela-cadastro-content">
      <!-- Coluna esquerda - Informações -->
      <div class="n-tela-cadastro-info">
        <!-- Logo e botão de boas-vindas -->
        <div class="n-header-info">
          <img
            class="n-logo"
            src="assets/icons/nomoh_logo.svg"
            alt="Nomoh Logo"
          />
          <button class="n-welcome-btn" disabled>
            <i class="pi pi-star"></i>
            Bem-vindo a Nomos Horizon
          </button>
        </div>

        <!-- Título principal -->
        <div class="n-title-section">
          <h1 class="n-main-title">
            Crie sua conta e
            <strong>facilite seu dia a dia</strong>
            com nossas soluções
          </h1>
          <p class="n-main-subtitle">
            Transforme a gestão da sua vida pessoal com nossa plataforma
            completa. Configure tudo que precisa para começar a organizar suas
            atividades de forma profissional.
          </p>
        </div>

        <!-- Lista de benefícios -->
        <div class="n-benefits-list">
          <div class="n-benefit-item">
            <i class="pi pi-check n-check-icon"></i>
            <span>Cadastro completo e seguro</span>
          </div>
          <div class="n-benefit-item">
            <i class="pi pi-check n-check-icon"></i>
            <span>Organização de dados pessoais</span>
          </div>
          <div class="n-benefit-item">
            <i class="pi pi-check n-check-icon"></i>
            <span>Gestão de endereços e contatos</span>
          </div>
          <div class="n-benefit-item">
            <i class="pi pi-check n-check-icon"></i>
            <span>Integração com redes sociais</span>
          </div>
        </div>
      </div>

      <!-- Coluna direita - Formulário -->
      <div class="n-tela-cadastro-form">
        <div class="n-form-card">
          <!-- Header do formulário -->
          <div class="n-form-header">
            <!-- <h2 class="n-form-title">{{ "PAGINA_CADASTRO.TITULO" | translate }}</h2> -->
            <p class="n-form-subtitle">
              Siga os passos abaixo para criar sua conta
            </p>
          </div>

          <form [formGroup]="form" (ngSubmit)="salvar()" class="n-form-grid">
            <!-- Upload de Foto de Perfil -->
            <div class="n-form-section">
              <div class="n-upload-container">
                <div class="n-avatar-wrapper">
                  <div class="n-avatar" [class.n-has-image]="filePreviewUrl">
                    <img
                      *ngIf="filePreviewUrl; else avatarPlaceholder"
                      [src]="filePreviewUrl"
                      alt="Preview da foto"
                      class="n-avatar-image"
                    />
                    <ng-template #avatarPlaceholder>
                      <i class="pi pi-user n-avatar-icon"></i>
                    </ng-template>
                  </div>

                  <div class="n-upload-actions">
                    <p-fileUpload
                      #fileUpload
                      name="foto[]"
                      accept="image/*"
                      maxFileSize="10000000"
                      (onSelect)="imagemSelecionada($event, fileUpload)"
                      mode="basic"
                      [auto]="true"
                      chooseIcon="pi pi-camera"
                      chooseLabel=""
                      class="n-upload-btn"
                    ></p-fileUpload>

                    <button
                      *ngIf="filePreviewUrl"
                      type="button"
                      pButton
                      icon="pi pi-trash"
                      class="p-button-rounded p-button-sm p-button-danger n-remove-btn"
                      (click)="removerImagem()"
                    ></button>
                  </div>
                </div>
                <small class="n-upload-hint"
                  >Adicione uma foto de perfil (opcional)</small
                >
              </div>
            </div>

            <!-- Dados Pessoais -->
            <div class="n-form-section">
              <h3 class="n-section-title">
                <i class="pi pi-user"></i>
                {{ "PAGINA_CADASTRO.DADOS_PESSOAIS" | translate }}
              </h3>

              <div class="n-field-group">
                <div class="n-field n-field-full">
                  <app-form-field
                    label="{{
                      'CAMPO_ENTRADA.NOME_COMPLETO.ROTULO' | translate
                    }}"
                    controlName="nomeCompleto"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="nomeCompleto"
                      placeholder="Digite o nome completo"
                      autocomplete="off"
                    />
                  </app-form-field>
                </div>

                <div class="n-field n-field-large">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.CPF.ROTULO' | translate }}"
                    controlName="cpfCnpj"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="cpfCnpj"
                      (input)="formatarCpfCnpj($event)"
                      placeholder="000.000.000-00"
                      autocomplete="off"
                    />
                  </app-form-field>
                </div>

                <div class="n-field n-field-large">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.TELEFONE.ROTULO' | translate }}"
                    controlName="telefone"
                    [required]="true"
                  >
                    <p-inputMask
                      formControlName="telefone"
                      mask="(99) 99999-9999"
                      placeholder="(00) 00000-0000"
                      autocomplete="off"
                    ></p-inputMask>
                  </app-form-field>
                </div>

                <div class="n-field n-field-full">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.EMAIL.ROTULO' | translate }}"
                    controlName="email"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="email"
                      type="email"
                      placeholder="Digite o seu e-mail"
                      autocomplete="off"
                    />
                  </app-form-field>
                </div>

                <div class="n-field n-field-large">
                  <app-form-field
                    label="{{
                      'PAGINA_CADASTRO.EDITAR.DADOS_PESSOAIS.REDESOCIAL'
                        | translate
                    }}"
                    controlName="redeSocial"
                  >
                    <input
                      pInputText
                      formControlName="redeSocial"
                      placeholder="@seuusuario"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="false"
                    />
                  </app-form-field>
                </div>

                <div class="n-field n-field-large">
                  <app-form-field
                    label="{{
                      'PAGINA_CADASTRO.EDITAR.DADOS_PESSOAIS.WEBSITE'
                        | translate
                    }}"
                    controlName="website"
                  >
                    <input
                      pInputText
                      formControlName="website"
                      placeholder="https://seusite.com"
                      type="url"
                      autocomplete="off"
                    />
                  </app-form-field>
                </div>
              </div>
            </div>

            <!-- Segurança -->
            <div class="n-form-section" formGroupName="seguranca">
              <h3 class="n-section-title">
                <i class="pi pi-lock"></i>
                {{ "PAGINA_CADASTRO.EDITAR.TITULO_SENHAS.TITULO" | translate }}
              </h3>

              <div class="n-field-group">
                <div class="n-field n-field-large">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.SENHA.ROTULO' | translate }}"
                    controlName="senha"
                    [required]="true"
                  >
                    <p-password
                      formControlName="senha"
                      autocomplete="off"
                      [toggleMask]="true"
                      [strongRegex]="regexSenha"
                      placeholder="Digite sua nova senha"
                      [feedback]="true"
                      styleClass="w-full"
                    >
                      <ng-template pTemplate="footer">
                        <div class="n-password-requirements">
                          <p class="n-requirements-title">
                            A senha deve conter pelo menos:
                          </p>
                          <ul class="n-requirements-list">
                            <li
                              class="n-requirement-item"
                              [ngClass]="{
                                'n-requirement-valid': hasUpperCase()
                              }"
                            >
                              <i
                                class="pi"
                                [ngClass]="
                                  hasUpperCase() ? 'pi-check' : 'pi-times'
                                "
                              ></i>
                              Uma letra maiúscula
                            </li>
                            <li
                              class="n-requirement-item"
                              [ngClass]="{
                                'n-requirement-valid': hasLowerCase()
                              }"
                            >
                              <i
                                class="pi"
                                [ngClass]="
                                  hasLowerCase() ? 'pi-check' : 'pi-times'
                                "
                              ></i>
                              Uma letra minúscula
                            </li>
                            <li
                              class="n-requirement-item"
                              [ngClass]="{
                                'n-requirement-valid': hasNumber()
                              }"
                            >
                              <i
                                class="pi"
                                [ngClass]="
                                  hasNumber() ? 'pi-check' : 'pi-times'
                                "
                              ></i>
                              Um número
                            </li>
                            <li
                              class="n-requirement-item"
                              [ngClass]="{
                                'n-requirement-valid': hasSpecialChar()
                              }"
                            >
                              <i
                                class="pi"
                                [ngClass]="
                                  hasSpecialChar() ? 'pi-check' : 'pi-times'
                                "
                              ></i>
                              Um caractere especial (#, $, etc)
                            </li>
                            <li
                              class="n-requirement-item"
                              [ngClass]="{
                                'n-requirement-valid': hasMinLength()
                              }"
                            >
                              <i
                                class="pi"
                                [ngClass]="
                                  hasMinLength() ? 'pi-check' : 'pi-times'
                                "
                              ></i>
                              8 caracteres no mínimo
                            </li>
                          </ul>
                        </div>
                      </ng-template>
                    </p-password>
                  </app-form-field>
                </div>

                <div class="n-field n-field-large">
                  <app-form-field
                    label="{{
                      'CAMPO_ENTRADA.CONFIRMAR_SENHA.ROTULO' | translate
                    }}"
                    controlName="confirmarSenha"
                    [required]="true"
                  >
                    <p-password
                      formControlName="confirmarSenha"
                      [feedback]="false"
                      [toggleMask]="true"
                      placeholder="Confirme sua senha"
                      autocomplete="off"
                    ></p-password>
                  </app-form-field>
                </div>
              </div>
            </div>

            <!-- Endereço -->
            <div class="n-form-section" formGroupName="endereco">
              <h3 class="n-section-title">
                <i class="pi pi-home"></i>
                {{ "PAGINA_CADASTRO.ENDERECO" | translate }}
              </h3>

              <!-- Linha 1: CEP + Logradouro -->
              <div class="flex flex-column md:flex-row w-full gap-3 mb-3">
                <!-- CEP em destaque -->
                <div class="w-full md:w-4 n-cep-section">
                  <div class="n-field">
                    <app-form-field
                      label="{{ 'CAMPO_ENTRADA.CEP.ROTULO' | translate }}"
                      controlName="codPostal"
                      [required]="true"
                      helpText="Preenchimento automático"
                    >
                      <p-inputMask
                        formControlName="codPostal"
                        mask="99999-999"
                        placeholder="00000-000"
                        (onBlur)="buscarCep($event)"
                        autocomplete="off"
                      ></p-inputMask>
                    </app-form-field>
                  </div>
                </div>
                <div class="w-full md:w-8 n-field">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.LOGRADOURO.ROTULO' | translate }}"
                    controlName="logradouro"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="logradouro"
                      placeholder="Digite o logradouro"
                      autocomplete="off"
                    />
                  </app-form-field>
                </div>
              </div>

              <!-- Linha 2: Número + Complemento -->
              <div class="flex flex-column md:flex-row w-full gap-3 mb-3">
                <div class="w-full md:w-3 n-field">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.NUMERO.ROTULO' | translate }}"
                    controlName="numero"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="numero"
                      placeholder="123"
                      autocomplete="off"
                    />
                  </app-form-field>
                </div>

                <div class="w-full md:w-9 n-field">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.COMPLEMENTO.ROTULO' | translate }}"
                    controlName="complemento"
                  >
                    <input
                      pInputText
                      formControlName="complemento"
                      placeholder="Complemento (Opcional)"
                      autocomplete="off"
                    />
                  </app-form-field>
                </div>
              </div>

              <!-- Linha 3: Bairro + Cidade -->
              <div class="flex flex-column md:flex-row w-full gap-3 mb-3">
                <div class="w-full md:w-6 n-field">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.BAIRRO.ROTULO' | translate }}"
                    controlName="bairro"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="bairro"
                      placeholder="Digite o bairro"
                      autocomplete="off"
                    />
                  </app-form-field>
                </div>

                <div class="w-full md:w-6 n-field">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.CIDADE.ROTULO' | translate }}"
                    controlName="cidade"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="cidade"
                      placeholder="Digite a cidade"
                      autocomplete="off"
                    />
                  </app-form-field>
                </div>
              </div>

              <!-- Linha 4: Estado + País -->
              <div class="flex flex-column md:flex-row w-full gap-3">
                <div class="w-full md:w-6 n-field">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.ESTADO.ROTULO' | translate }}"
                    controlName="estado"
                    [required]="true"
                  >
                    <p-dropdown
                      [options]="estados"
                      formControlName="estado"
                      placeholder="Selecione..."
                      id="estado"
                      autocomplete="off"
                      [styleClass]="'w-full'"
                    />
                  </app-form-field>
                </div>

                <div class="w-full md:w-6 n-field">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.PAIS.ROTULO' | translate }}"
                    controlName="pais"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="pais"
                      autocomplete="off"
                    />
                  </app-form-field>
                </div>
              </div>
            </div>

            <!-- Botões de Ação -->
            <div class="n-form-actions">
              <p-button
                label="{{ 'BOTAO.VOLTAR' | translate }}"
                (onClick)="cancelar()"
                [disabled]="isLoading()"
                severity="secondary"
                styleClass="n-button-sec"
                type="button"
              ></p-button>

              <p-button
                label="{{ 'BOTAO.CRIAR_CONTA' | translate }}"
                [loading]="isLoading()"
                styleClass="n-button-prim"
                type="submit"
              ></p-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Dialog de Confirmação -->
<p-confirmDialog #cd>
  <ng-template pTemplate="headless" let-message>
    <div class="n-confirm-dialog">
      <div class="n-confirm-icon">
        <i class="pi pi-user"></i>
      </div>
      <h3 class="n-confirm-title">{{ message.header }}</h3>
      <p class="n-confirm-message">{{ message.message }}</p>
      <div class="n-confirm-actions">
        <p-button
          label="OK"
          (onClick)="cd.accept()"
          styleClass="n-button-prim"
        ></p-button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
